import { render } from "./ForgotPassword.vue?vue&type=template&id=01266098"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=01266098&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01266098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01266098', __exports__)) {
    api.reload('01266098', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=01266098", () => {
    api.rerender('01266098', render)
  })

}


export default __exports__